import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { TenderBox } from "./Suppliers.styles";
import { ProductBox } from "./Customers.styles";
import { SecondSubTitleParagraph, SubTitleParagraph } from "./Layout.styles";

///////////////////////////////////////////
//////////////////header//////////////////
export const HeaderWrapper = styled.header`
  position: relative;
  margin-bottom: 60px;
  .swiper {
    height: 100vh;
  }
  .swiper-pagination-container {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 90px;
    height: max-content;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .swiper-pagination-bullets.swiper-pagination-horizontal {
    width: auto;
    left: unset;
    right: 16px;
    bottom: unset;
  }

  .swiper-button-next,
  .swiper-button-prev {
    top: 38%;
    color: #ffffff;
  }
  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 20px;
  }

  .swiper-pagination-bullet {
    background: #ffffff;
    opacity: 0.5;
    height: 6px;
    width: 6px;
    box-shadow: rgba(255, 255, 255, 0.2) 0 0 0 4px;
    transition: all 250ms ease-in-out;
  }
  .swiper-pagination-bullet-active {
    height: 10px;
    width: 10px;
    box-shadow: rgba(255, 255, 255, 0.4) 0 0 0 10px;
  }

  .swiper-pagination-bullets.swiper-pagination-horizontal
    .swiper-pagination-bullet {
    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 8px);
  }
  .swiper-pagination-bullets.swiper-pagination-horizontal
    .swiper-pagination-bullet-active {
    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 16px);
  }

  @media screen and (min-width: 1439px) {
    .swiper {
      height: 80vh;
    }
  }

  @media screen and (max-width: 900px) {
    .swiper-pagination-bullets.swiper-pagination-horizontal {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media screen and (max-height: 666px) {
    height: 150vh;
    .swiper {
      height: 100%;
    }
  }
`;

export const SlideItem = styled.div`
  height: 100%;
  color: #ffffff;
  display: flex;
  align-items: center;
`;

export const SlideMediaWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: -1;

  img,
  video {
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    width: 100%;
    object-fit: cover;
    opacity: 0.3;
  }

  .videoWrapper {
    height: 100%;
    width: 100%;
    background: linear-gradient(
      0deg,
      rgba(0, 57, 143) 43.69%,
      rgba(0, 87, 218) 100%
    );
  }
  .imageWrapper {
    position: relative;
    width: 100%;
    height: 100%;
    /*min-width: 1920px;*/
    /*min-height: 1080px;*/
    background: linear-gradient(
      0deg,
      rgba(0, 57, 143) 43.69%,
      rgba(0, 87, 218) 100%
    );
  }
`;

export const SlideContentWrapper = styled.div`
  width: 100vw;
  .slideItemContentContainer {
    .slideItemContent {
      .title {
        font-weight: 800;
        font-size: clamp(40px, 4vw, 80px);
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        span {
          font-weight: 500;
          font-size: clamp(20px, 3vw, 50px);
        }
      }
      .content {
        font-weight: 400;
        font-size: clamp(22px, 1.5vw, 28px);
        line-height: 48px;
        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
        max-width: 800px;
        margin-bottom: 30px;
      }

      .footer-slider {
        width: 162px;
        position: absolute;
        bottom: 0;
        right: 20px !important;
      }
    }
  }

  @media screen and (min-width: 1439px) {
    height: calc(80vh - 170px);
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
  }

  @media screen and (min-width: 1100px) and (max-width: 1439px) {
    height: calc(100vh - 170px);
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
  }

  @media screen and (max-width: 900px) {
    height: calc(100vh - 115px);
    .slideItemContentContainer {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 500px;
      .slideItemContent {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }
    }
  }
  @media screen and (max-width: 666px) {
    .slideItemContentContainer {
      .slideItemContent {
        .title,
        .content {
          margin-bottom: 10px;
        }
      }
    }
  }

  @media screen and (max-height: 666px) {
    height: calc(150vh - 175px);
  }
`;

export const HeaderInfoBox = styled.div`
  padding: 10px;
  border-radius: 10px;
  border: 1px solid transparent;
  min-height: 100%;
  transition: all 250ms ease-in-out;
  &:hover {
    /*border: 1px solid #17479e;*/
    box-shadow: 0 0 10px 0 #8d8e91;
  }

  .headWrap {
    display: flex;
    align-items: center;
    margin-bottom: 21px;

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      margin-right: 6px;
      svg {
        path {
          fill: #17479e;
        }
      }
    }

    .title {
      font-weight: 500;
      font-size: 20px;
      line-height: 30px;
      color: #17479e;
    }
  }

  .text {
    font-weight: 400;
    font-size: 13px;
    line-height: 22px;
    color: #8d8e91;
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
      ".headWrap": {
        justifyContent: "center",
      },
      textAlign: "center",
    },
  })}
`;

///////////////////////////////////////////
/////////////////news/////////////////////
export const NewsWrapper = styled.section`
  padding: 60px 0;
  background: rgba(242, 242, 243, 0.6);
  h2 {
    margin-bottom: 60px;
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("lg")]: {
      padding: "60px 0 40px 0",
      h2: {
        marginBottom: 30,
      },
    },
  })}
`;

export const NewsList = styled.div`
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    h3 {
      font-weight: 700;
      font-size: clamp(22px, 2vw, 28px);
      line-height: 34px;
      letter-spacing: 0.02em;
      color: #000000;
    }
    span {
      font-weight: 500;
      font-size: 16px;
      line-height: 34px;
      text-align: right;
      letter-spacing: 0.02em;
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
      paddingInline: 16,
    },
  })}
`;

export const NewsBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 15px 0;
  :not(:last-child) {
    border-bottom: 1px solid #e6e6e7;
  }
  .imageWrapper {
    flex: 0 0 100px;
    width: 100px;
    height: 100px;
    overflow: hidden;
    border-radius: 8px;
    background-color: antiquewhite;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .content {
    p {
      font-weight: 700;
      font-size: 16px;
      line-height: 28px;
      color: #000000;
      margin-bottom: 6px;
    }
  }
`;

export const NewsItem = styled.div`
  position: relative;
  border-radius: 20px;
  overflow: hidden;

  .imageWrapper {
    position: relative;
    height: ${({ height }) => height + "px"};
  }
  .content {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      180deg,
      rgba(1, 64, 179, 0) 32.49%,
      #1144a0 82.81%
    );

    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    flex-direction: column;
    padding: 30px;

    p {
      color: #ffffff;
      ${props =>
        props.type === "lg"
          ? css`
              font-weight: 500;
              font-size: clamp(18px, 2vw, 22px);
              line-height: 30px;
              margin-bottom: 10px;
            `
          : props.type === "sm"
          ? css`
              font-weight: 700;
              font-size: 16px;
              line-height: 28px;
              margin-bottom: 16px;
            `
          : ""};
    }

    .date {
      span,
      svg path {
        color: #ffff;
        fill: #fff;
      }
    }
  }

  ${({ theme, type }) => ({
    [theme.breakpoints.down("sm")]: {
      borderRadius: 0,
      ".content": { padding: 20, p: { marginBottom: 10 } },
      // ".imageWrapper": {
      //   minHeight: type === "sm" ? 190 : 320,
      //   img: {
      //     width: "100%",
      //     height: "100%",
      //   },
      // },
    },
  })}
`;

////////////////////////////////////////////
//////////////////about////////////////////
export const ProductSectionWrapper = styled.section`
  padding: 60px 0;
  h2 {
    line-height: 1.3;
  }
  ${SubTitleParagraph} {
    margin-bottom: 50px;
  }
  ${TenderBox} {
    min-height: 340px;
  }
  ${ProductBox} {
    min-height: 310px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    ${({ theme }) => ({
      [theme.breakpoints.down("sm")]: {
        alignItems: "center",
        justifyContent: "center",
        minHeight: 220,
      },
    })}
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
      padding: "60px 0",
    },
  })}
`;

export const H2 = styled.h2`
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 28px;
  line-height: 48px;
  color: #000000;
`;

export const QuestionsBox = styled.div`
  background: #fbfbfc;
  border-radius: 15px;
  padding: 25px;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  .title {
    font-weight: 500;
    font-size: 28px;
    line-height: 34px;
    color: #000000;
    margin-bottom: 12px;
  }

  a {
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    color: #17479e;
    margin-bottom: 8px;
    display: inline-block;
    transition: all 250ms ease-in-out;

    &:last-of-type {
      margin-bottom: 0;
    }

    &:hover {
      color: #0053ff;
    }
  }
`;

////////////////////////////////////////////
//////////////////about////////////////////
export const AboutWrapper = styled.section`
  padding: 60px 0;

  .read-more {
    margin-top: 30px;
  }

  .MuiDivider-root {
    border-width: 1px;
    border-color: #cccdce;
  }

  .aboutBoxInfo {
    .imageWrapper {
      position: relative;
      width: 130px;
      height: 130px;
      overflow: hidden;
      border-radius: 50%;
      background-color: antiquewhite;
    }
    .content {
      .title {
        font-weight: 500;
        font-size: clamp(20px, 2vw, 22px);
        line-height: 24px;
        letter-spacing: 0.02em;
        color: ${({ theme }) => theme.palette.primary.main};
        margin-bottom: 10px;
      }
      .text {
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        color: #000000;
      }
    }
  }
  ${({ theme, type }) => ({
    [theme.breakpoints.down("lg")]: {
      padding: "60px 0",
    },
    [theme.breakpoints.down("sm")]: {
      ".content": {
        textAlign: "center",
      },
    },
  })}
`;

////////////////////////////////////////////
//////////////sustainability///////////////
export const SustainWrapper = styled.section`
  padding: 60px 0;
  .section-subtitle {
    color: #fff;
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("lg")]: {
      padding: "60px 0",
    },
  })}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 766px;
  overflow: hidden;
  h4 {
    margin-bottom: 28px;
  }
  .read-more {
    margin-top: 30px;
  }
  ${SecondSubTitleParagraph} {
    font-size: clamp(16px, 2vw, 18px);
    text-transform: lowercase;
    &:first-letter {
      text-transform: uppercase;
    }
  }
  ${({ theme, type }) => ({
    [theme.breakpoints.down("sm")]: {
      h4: {
        marginBottom: 20,
      },
      ".read-more": {
        marginTop: 20,
      },
    },
  })};

  @media screen and (max-width: 950px) {
    max-width: 100%;
    .smallScreenBoxWrapper {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(89px, 1fr));
      column-gap: 10px;
      margin: 100px 0 50px 0;
    }
  }
  @media screen and (max-width: 700px) {
    .smallScreenBoxWrapper {
      row-gap: 16px;
    }
  }
`;

export const SustainBox = styled.div`
  position: relative;
  background-color: ${({ active, theme }) =>
    active ? theme.palette.primary.main : "rgba(255, 255, 255, 0.1)"};
  border-radius: 15px;
  padding: 30px 25px;
  cursor: pointer;
  overflow: hidden;
  transition: background-color 250ms ease-in-out;
  :not(:last-child) {
    margin-bottom: 10px;
  }
  :hover {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
  p {
    font-weight: 700;
    font-size: clamp(18px, 1.8vw, 22px);
    line-height: 30px;
    color: #ffffff;
    margin-top: 10px;
  }
  .imageWrapper {
    width: 60px;
  }
  .overlay {
    position: absolute;
    width: 125px;
    top: -20px;
    right: -34px;
    img {
      opacity: 0.2;
    }
  }
  @media screen and (max-width: 950px) {
    padding: 16px 18px;
    :not(:last-child) {
      margin-bottom: 0;
    }
  }
  @media screen and (max-width: 845px) {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    .overlay {
      display: none;
    }
    .imageWrapper {
      flex: 0 0 60px;
    }
  }
  @media screen and (max-width: 700px) {
    min-width: 89px;
    min-height: 89px;
    .overlay,
    p {
      display: none;
    }
  }
`;

////////////////////////////////////////////
//////////////////glance///////////////////
export const GlanceWrapper = styled.section`
  padding: 60px 0;
  .section-subtitle {
    margin-bottom: 100px;
  }
  .MuiGrid-item:nth-of-type(3n + 2) {
    border: 1px solid #e6e6e7;
    border-bottom: none;
    border-top: none;
  }
  ${({ theme }) => ({
    [theme.breakpoints.up("lg")]: {
      ".MuiGrid-item:nth-of-type(2)": {
        paddingBottom: 80,
      },
    },
    [theme.breakpoints.down("lg")]: {
      padding: "60px 0",
      ".section-subtitle": {
        marginBottom: 80,
      },
      ".MuiGrid-item:nth-of-type(3n + 2)": {
        border: "none",
      },
    },
  })}
`;

export const GlanceInfoBox = styled.div`
  padding: 0 40px;
  .icon {
    display: block;
    width: 70px;
    height: 70px;
    background: #eaf0ff;
    border-radius: 55px;
    margin-bottom: 15px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .count {
    display: inline-block;
    font-weight: 700;
    font-size: 38px;
    line-height: 32px;
    color: ${({ theme }) => theme.palette.primary.main};
    margin-bottom: 15px;
  }
  .valueType {
    font-weight: 700;
    font-style: normal;
    font-size: 28px;
    color: ${({ theme }) => theme.palette.primary.main};
  }
  .title {
    font-weight: 500;
    font-size: 18px;
    line-height: 31px;
    color: ${({ theme }) => theme.palette.gray};
    margin-bottom: 10px;
  }
  .text {
    font-weight: 500;
    font-size: 20px;
    line-height: 22px;
    color: ${({ theme }) => theme.palette.gray};
    letter-spacing: -0.011em;
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("lg")]: {
      textAlign: "center",
      i: {
        marginInline: "auto",
      },
    },
    [theme.breakpoints.down("sm")]: {
      ".valueWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 15,
        marginBottom: 15,
        i: {
          margin: 0,
        },
        ".valueContainer .count": {
          margin: 0,
        },
      },
    },
  })}
`;

///

export const DateDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  .date {
    display: flex;
    align-items: center;
  }

  i {
    display: flex;
    margin-right: 4px;
    svg {
      width: 14px;
    }
  }
  span {
    font-weight: 500;
    font-size: 12px;
    line-height: 22px;
    color: #808285;
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      i: {
        svg: {
          width: "17px",
        },
      },
      span: {
        fontSize: "14px",
      },
    },
  })}
`;

export const ShareDiv = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 20px;
  .date {
    display: flex;
    align-items: center;
  }

  i {
    display: flex;
    margin-right: 4px;
    svg {
      width: 14px;
    }
  }
  span {
    font-weight: 500;
    font-size: 12px;
    line-height: 22px;
    color: #808285;
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      i: {
        svg: {
          width: "17px",
        },
      },
      span: {
        fontSize: "14px",
      },
    },
  })}
`;

export const DivRow = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      i: {
        svg: {
          width: "17px",
        },
      },
      span: {
        fontSize: "14px",
      },
    },
  })}
`;

export const ShareLinkPopup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .share-popup {
    background-color: white;
    padding: 20px 30px;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    max-width: 90%;
    text-align: center;
    transition: transform 0.3s ease;
  }

  .url-box {
    padding: 15px 25px;
    background-color: #f7f7f7;
    border: 1px solid #ccc;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    color: #333;
    width: 100%;
    word-break: break-all;
    transition: background-color 0.3s ease, border-color 0.3s ease;
  }
  .copy-instruction {
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
  }
  .url-box:hover {
    background-color: #dcdee0;
    border-color: #bbb;
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 15px;
    cursor: pointer;
    color: #aaa;
    transition: color 0.3s ease;
  }

  .close-button:hover {
    color: #555;
  }
`;
